import {Component, NgZone, OnInit, Renderer2} from '@angular/core';
import {APP_ASSIGN_FOLDER, APP_ICON_PATH} from '../../../environments/environment';
import {Chooser} from '@awesome-cordova-plugins/chooser/ngx';
import {AlertController, IonicSafeString, LoadingController, ToastController} from '@ionic/angular';
import {Camera, CameraOptions} from '@awesome-cordova-plugins/camera/ngx';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {UserService} from '../../provider/user/user.service';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {StorageService} from '../../provider/storage/storage.service';
import {
	FileTransfer,
	FileTransferObject,
	FileUploadOptions,
	FileUploadResult
} from '@awesome-cordova-plugins/file-transfer/ngx';
import {ConfigurationObject} from '../../interfaces/interfaces.regisafe';
import {AppConfig} from '../../app.config';
import {Directory} from '@capacitor/filesystem';
import write_blob, {BlobWriteOptions} from 'capacitor-blob-writer';
import {ImagePicker, ImagePickerOptions} from '@awesome-cordova-plugins/image-picker/ngx';
import {FileOpener} from '@awesome-cordova-plugins/file-opener/ngx';
import {ALERT_TXT, TOAST_TXT} from '../../strings/language';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';

declare let cordova: any;

@Component({
	selector: 'app-dateien-zuordnen',
	templateUrl: './dateien-zuordnen.page.html',
	styleUrls: ['./dateien-zuordnen.page.scss'],
})
export class DateienZuordnenPage implements OnInit {

	public configuration: ConfigurationObject;

	appIconPath = APP_ICON_PATH;
	filesToAssign: Array<object> = [];
	markedFiles: Array<any> = [];
	loader: HTMLIonLoadingElement;
	toast: HTMLIonToastElement;

	constructor(private chooser: Chooser,
				private picker: ImagePicker,
				private renderer: Renderer2,
				private fileOpener: FileOpener,
				private alertCtrl: AlertController,
				private loadingCtrl: LoadingController,
				private toastCtrl: ToastController,
				private dateiSystem: DateiSystemService,
				public userService: UserService,
				private camera: Camera,
				private iqAPI: IQApiService,
				private storageService: StorageService,
				public appConfig: AppConfig,
				private transfer: FileTransfer,
				private errorHandling: ErrorHandlingService,
				public zone: NgZone) {
		this.configuration = this.appConfig.getConfig();
	}

	ngOnInit() {
	}

	ionViewDidEnter() {
		this.readExistingFiles();
	}

	back() {
	}

	toggleFile(event, file) {

		const className = 'marked';
		const hasClass = event.target.classList.contains(className);

		if (hasClass) {
			this.renderer.removeClass(event.target, className);
			const filtered = this.markedFiles.filter((o: any) => {
				return o.filename !== file.filename;
			});
			this.markedFiles = filtered;
		} else {
			this.renderer.addClass(event.target, className);
			this.markedFiles.push(file);
		}

	}

	public getFileIcon(filename: string): any {
		const extension = filename.split('.').pop();

		const iconList: any = {};
		iconList.default = ['far', 'file-lines'];

		iconList.doc = ['far', 'file-word'];
		iconList.docx = ['far', 'file-word'];
		iconList.xls = ['far', 'file-excel'];
		iconList.xlsx = ['far', 'file-excel'];

		iconList.rtf = ['far', 'file-lines'];
		iconList.txt = ['far', 'file-lines'];

		iconList.pdf = ['far', 'file-pdf'];

		iconList.jpg = ['far', 'file-image'];
		iconList.jpeg = ['far', 'file-image'];
		iconList.png = ['far', 'file-image'];

		if (iconList.hasOwnProperty(extension)) {
			return iconList[extension];
		} else {
			return iconList.default;
		}

	}

	async addFile() {
		const addAlert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00040,
			subHeader: ALERT_TXT.subHeader.str00060,
			buttons: [{
				text: ALERT_TXT.buttons.str00010,
				role: 'cancel'
			}, {
				text: ALERT_TXT.buttons.str00120,
				handler: () => {
					this.fromCamera();
				}
			}, {
				text: ALERT_TXT.buttons.str00100,
				handler: () => {
					this.fromGalery();
				}
			}, {
				text: ALERT_TXT.buttons.str00110,
				handler: () => {
					this.chooseFile();
				}
			}]
		});

		await addAlert.present();
		await addAlert.onDidDismiss().then((data) => {
			// no Data
		});
	}

	async fromCamera() {
		const options: CameraOptions = {
			quality: 80,
			destinationType: this.camera.DestinationType.DATA_URL,
			encodingType: this.camera.EncodingType.JPEG,
			mediaType: this.camera.MediaType.PICTURE
		};
		this.camera.getPicture(options).then(async (imageData) => {

			const dateiname = await this.userService.getCurrentDate() + '_regisafeapp.jpg';
			const blobData = this.userService.base64toBlob(imageData, 'image/jpeg');

			const blobOptions: BlobWriteOptions = {
				path: APP_ASSIGN_FOLDER + '/' + dateiname,
				directory: Directory.Documents,
				blob: blobData,
				recursive: true
			};

			write_blob(blobOptions)
				.then((data) => {
					this.readExistingFiles();
				})
				.catch((e) => {
					console.log('write_blob error: ', e);
				});


		}, (err) => {
			// Handle error
			console.log('imageData: ', err);
		});

	}

	async fromGalery() {
		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}
		const options: ImagePickerOptions = {
			quality: 80,
			maximumImagesCount: 5,
			outputType: 0
		};
		this.picker.getPictures(options)
			.then(async (images) => {
				this.copyImages(images);
			})
			.catch((e) => {
				console.log('getPictures error: ', e);
				this.readExistingFiles();
				this.dismissLoader();
			});
	}

	async copyImages(images: Array<string>): Promise<any> {

		const dateiname = images[0].split('/').pop();
		const kopiere = await this.dateiSystem.kopiereDateiNach(images[0], APP_ASSIGN_FOLDER, dateiname);

		if (kopiere) {
			images.splice(0, 1);
			if (images.length > 0) {
				setTimeout(() => {
					this.copyImages(images);
				}, 250);
			} else {
				this.readExistingFiles();
				this.dismissLoader();
			}
		} else {
			this.dismissLoader();
			console.log('kopiereDateiNach error: ', kopiere);
		}

	}

	async chooseFile(): Promise<any> {
		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}
		this.chooser.getFile()
			.then((data) => {
				const dataURI = data.dataURI; // base64
				const base64data = dataURI.split(',').pop();
				const type = data.mediaType;
				const dateiname = data.name;
				const blobData = this.userService.base64toBlob(base64data, type);
				const blobOptions: BlobWriteOptions = {
					path: APP_ASSIGN_FOLDER + '/' + dateiname,
					directory: Directory.Documents,
					blob: blobData,
					recursive: true
				};

				write_blob(blobOptions)
					.then((blob) => {
						this.readExistingFiles();
						this.dismissLoader();
					})
					.catch((e) => {
						console.log('write_blob error: ', e);
						this.dismissLoader();
					});
			})
			.catch((e) => {
				console.log('chooseFile error: ', e);
				this.dismissLoader();
			});
	}

	async readExistingFiles() {

		this.filesToAssign = [];
		const existing = await this.dateiSystem.leseDateienInOrdner(APP_ASSIGN_FOLDER);

		if (existing.hasOwnProperty('files')) {
			if (existing.files.length > 0) {
				for (const file of existing.files) {
					const info = await this.dateiSystem.getFileInfo(APP_ASSIGN_FOLDER + file);
					const fileExt = file.split('.').pop();
					const mimeType = this.userService.mimeTypes[fileExt];
					this.filesToAssign.push({filename: file, meta: info, type: mimeType});
				}
			}

		}
	}

	async uploadFile(file, loop?: boolean) {

		console.log('### uploadFile ###: ', file);

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create(
				{duration: 10000, message: ''}
			);
			await this.loader.present();
		}

		const fileEntry = {
			name: decodeURIComponent(file.filename),
			uri: decodeURIComponent(file.meta.uri)
		};
		const token = this.storageService.getToken();
		const fileTransfer: FileTransferObject = this.transfer.create();
		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: fileEntry.name,
			mimeType: file.type,
			httpMethod: 'POST',
			chunkedMode: false,
			params: {
				apiID: this.configuration.iqapiAppId,
				sessionToken: token,
				fileName: fileEntry.name,
				dontOpenDlg: 1
			}
		};

		fileTransfer.onProgress((event) => {
			console.log('transferObj.onProgress: ', event.loaded);
			let markedFilesCount = this.markedFiles.length;
			if (markedFilesCount === 0) {
				markedFilesCount = 1;
			}
			this.loader.message = markedFilesCount.toString() + ' / ' + this.userService.niceBytes(event.loaded).toString();
			this.zone.run(() => {
			});
		});

		const url = this.configuration.iqapiEndpoint + '/OrgaManager.HandFile';

		fileTransfer.upload(fileEntry.uri, url, transferOption, true)
			.catch((e) => {
				console.log('transferObj error: ', e);
			})
			.then(async (result: FileUploadResult) => {
				console.log('transferObj result: ', result);
				if (loop) {
					if (this.markedFiles.length > 0) {
						const loesche = await this.dateiSystem.loescheDatei(APP_ASSIGN_FOLDER + file.filename);
						if (loesche) {
							this.markedFiles.splice(0, 1);
							setTimeout(() => {
								this.uploadFiles();
							}, 200);
						}
					}
				} else {
					this.deleteFile(file);
					this.dismissLoader();
					this.errorHandling.errorMessage(TOAST_TXT.message.str00011, 'toast', false);
				}
			});
	}

	async uploadFiles() {
		if (this.markedFiles.length > 0) {
			this.uploadFile(this.markedFiles[0], true);
		} else {
			this.readExistingFiles();
			this.dismissLoader();
			this.errorHandling.errorMessage(TOAST_TXT.message.str00012, 'toast', false);
		}
	}

	async deleteFile(file) {
		const loesche = await this.dateiSystem.loescheDatei(APP_ASSIGN_FOLDER + file.filename);
		if (loesche) {
			this.readExistingFiles();
		}
	}

	async deleteFiles() {
		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}
		const loesche = await this.dateiSystem.loescheDatei(APP_ASSIGN_FOLDER + this.markedFiles[0].filename);
		if (loesche) {
			this.markedFiles.splice(0, 1);
			if (this.markedFiles.length > 0) {
				this.deleteFiles();
			} else {
				this.dismissLoader();
				this.readExistingFiles();
			}
		} else {
			this.dismissLoader();
			this.readExistingFiles();
			this.showToast(this.markedFiles[0].filename + ' konnte nicht gelöscht werden!');
		}
	}

	viewFile(file) {
		console.log('viewFile: ', file);
		try {
			const fileOpener = this.fileOpener.open(file.meta.uri, file.type)
				.then((data) => {
					console.log('fileOpener: ', data);
				})
				.catch((e) => {
					console.log('fileOpener error: ', e);
				});
		} catch (e) {
			console.log('viewFile error: ', e);
		}
	}


	async editFile(file) {
		console.log('editFile: ', file);
		let fileOpenercomundus = null;
		try {
			fileOpenercomundus = cordova.plugins.fileOpener2comundus;
		} catch (e) {
			console.log('Lorem: ', e);
		}
		fileOpenercomundus.showOpenWithDialog(file.meta.uri, file.type, {
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			success() {
				console.log('showOpenWithDialog');
			},
			// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
			error(e) {
				console.log('showOpenWithDialog error: ', e);
			}
		});
	}

	async showToast(msg) {
		this.toast = await this.toastCtrl.create({message: msg});
		await this.toast.present();
	}

	async dismissLoader() {
		try {
			this.loader.dismiss();
			this.loader = null;
		} catch (e) {
			console.log('dismissToast: ', e);
		}
	}


}
